import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineStore } from 'pinia';
import { SpecialitiesApi } from '~/core/api';
import { familyApi } from '~/core/api/familyApi';
import { mapFamily } from '~/core/functions/mappers/mapFamily';
export default defineStore('main', function () {
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;

  /** region family */
  var family = ref([]);
  var interactiveFamilyProfiles = computed(function () {
    return family.value.filter(function (profile) {
      return !profile.isAppOnlyInteractive;
    });
  });
  var mainProfile = computed(function () {
    return family.value.find(function (member) {
      return member.isMain;
    });
  });
  var isMainProfileChild = computed(function () {
    var _mainProfile$value;
    return Boolean((_mainProfile$value = mainProfile.value) === null || _mainProfile$value === void 0 ? void 0 : _mainProfile$value.isChild);
  });
  function getFamilyProfile(uuid) {
    return family.value.find(function (_ref) {
      var userUuid = _ref.uuid;
      return userUuid === uuid;
    });
  }
  function getFamilyProfileByUuidOrMain(uuid) {
    var _getFamilyProfile;
    if (!uuid) {
      return mainProfile.value;
    }
    return (_getFamilyProfile = getFamilyProfile(uuid)) !== null && _getFamilyProfile !== void 0 ? _getFamilyProfile : mainProfile.value;
  }
  function fetchFamily() {
    return _fetchFamily.apply(this, arguments);
  }
  /** endregion family */
  /** region featureFlags */
  function _fetchFamily() {
    _fetchFamily = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var force,
        _useNuxtApp2,
        $featureFlag,
        _yield$Promise$all,
        _yield$Promise$all2,
        masterData,
        profileData,
        infoData,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            _useNuxtApp2 = useNuxtApp(), $featureFlag = _useNuxtApp2.$featureFlag;
            if (!(family.value.length && !force)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _context.next = 6;
            return Promise.all([familyApi.getFamilyListFromMaster(), familyApi.getFamilyListFromProfile(), familyApi.getFamilyListFromInfo()]);
          case 6:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            masterData = _yield$Promise$all2[0].data;
            profileData = _yield$Promise$all2[1].data;
            infoData = _yield$Promise$all2[2].data;
            family.value = mapFamily(masterData, profileData, infoData, $captureException, $featureFlag('wff_family_profiles_transfer'));
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchFamily.apply(this, arguments);
  }
  var featureFlags = ref({});
  /** endregion featureFlags */

  /** region specialities */
  var specialities = ref([]);
  function getSpecialityById(id) {
    return specialities.value.find(function (speciality) {
      return speciality.id === id;
    });
  }
  function fetchSpecialities() {
    return _fetchSpecialities.apply(this, arguments);
  }
  /** endregion specialities */
  /** region isLayoutError */
  function _fetchSpecialities() {
    _fetchSpecialities = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$SpecialitiesAp, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!specialities.value.length) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return SpecialitiesApi.getAll();
          case 5:
            _yield$SpecialitiesAp = _context2.sent;
            data = _yield$SpecialitiesAp.data;
            specialities.value = data;
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](2);
            $captureException(_context2.t0, {
              component: 'useMainStore',
              method: 'fetchSpecialities'
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 10]]);
    }));
    return _fetchSpecialities.apply(this, arguments);
  }
  var isLayoutError = ref(false);
  /** endregion isLayoutError */

  /** region overlaysCount */
  var overlaysCount = ref(0);
  function incOverlaysCount() {
    overlaysCount.value++;
  }
  function decOverlaysCount() {
    if (overlaysCount.value > 0) {
      overlaysCount.value--;
    }
  }
  /** endregion overlaysCount */

  /** region isSmartAppBannerActive */
  var isSmartAppBannerActive = ref(false);
  /** endregion isSmartAppBannerActive */

  function clear() {
    family.value = [];
  }
  return {
    family: family,
    interactiveFamilyProfiles: interactiveFamilyProfiles,
    mainProfile: mainProfile,
    isMainProfileChild: isMainProfileChild,
    getFamilyProfile: getFamilyProfile,
    getFamilyProfileByUuidOrMain: getFamilyProfileByUuidOrMain,
    fetchFamily: fetchFamily,
    featureFlags: featureFlags,
    specialities: specialities,
    getSpecialityById: getSpecialityById,
    fetchSpecialities: fetchSpecialities,
    isLayoutError: isLayoutError,
    overlaysCount: overlaysCount,
    incOverlaysCount: incOverlaysCount,
    decOverlaysCount: decOverlaysCount,
    isSmartAppBannerActive: isSmartAppBannerActive,
    clear: clear
  };
});